import { http } from "./client";

export const fetchClientSearch = (params) => http.get("Client/search", { params });
